import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'

import { ToursHeader } from 'pages/tours/search-result-page/components'
import { useHeaderMeta } from 'pages/tours/search-result-page/model'

import { selectionStore } from 'entities/tour/models'

import ImageBag from 'shared/images/bag.svg'
import { Button } from 'shared/ui/button'
import { EmptyResults } from 'shared/ui/empty-result'

import { HotelListCard } from './components/hotel-list-card'
import s from './styles.module.scss'

const HotelRoomsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { title, subtitle } = useHeaderMeta()
  const hotelDetail = selectionStore.getSelectedHotel()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <div>
      <ToursHeader
        onGoBack={handleBack}
        title={title}
        subtitle={subtitle}
      />

      {hotelDetail && (hotelDetail?.tours?.length || 0) > 0 ? (
        <div className={clsx('container', s.container)}>
          {hotelDetail.tours.map((room) => (
            <HotelListCard
              key={room.id}
              room={room}
            />
          ))}
        </div>
      ) : (
        <div className={s.empty}>
          <EmptyResults
            image={
              <img
                src={ImageBag}
                alt="bag image"
                className={s.image}
              />
            }
            title={t('tours_block.not_found')}
            subTitle={t('tours_block.empty_rooms')}
            button={
              <Button
                className={s.backButton}
                onClick={handleBack}
              >
                {t('tours_block.back')}
              </Button>
            }
          />
        </div>
      )}
    </div>
  )
}

export default HotelRoomsPage
